import { Type } from '@angular/core';
import { Routes } from '@angular/router';
import { KA_MASKEN, KaMaskeId } from './ka-maske';
import { KaTitelComponent } from './ka-titel.component';
import { KaSituationComponent } from './ka-situation.component';
import { KaHorizonteComponent } from './ka-horizonte.component';
import { KaProfilComponent } from './ka-profil.component';

/**
 * Die Adressen der vier Eingabemasken der KA-Aufnahme, als Kinder von
 * `bohrpunkte/:id` (siehe `app-routing.module.ts`).
 *
 * **Die Adresse steht nicht hier, sondern in `KA_MASKEN`.** Derselbe Name ist auch
 * der Wert von `bpHl` in der Lese-Übersicht: Ein Klick auf eine Zeile führt auf
 * `bohrpunkte/<id>/<Name>`. Zwei getippte Fassungen davon würden auseinanderlaufen,
 * und der Klick führte ins Leere, ohne dass es jemand merkt - die Anweisung
 * navigiert einfach auf eine Adresse, die es nicht gibt.
 */
const BAUTEILE: Record<KaMaskeId, Type<unknown>> = {
	titel: KaTitelComponent,
	situation: KaSituationComponent,
	horizonte: KaHorizonteComponent,
	profil: KaProfilComponent,
};

export const KA_MASKEN_ROUTEN: Routes = KA_MASKEN.map(maske => ({
	path: maske.route,
	component: BAUTEILE[maske.id],
}));
